import React, { createContext, useContext, useReducer } from "react";

import { useAppStore } from "../hooks/useAppStore";
import { initialState, actionAppReducer } from "../hooks/useAppReducer";
import { ContextType } from "../types/state";

const AppContext = createContext<ContextType>({ state: initialState });
export const useAppContext = () => useContext(AppContext);

export const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  const contextValue = useAppStore(useReducer(actionAppReducer, initialState));

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
